import React, { useCallback, useEffect } from "react";

const useInfiniteScroll = (loader: React.MutableRefObject<null | any>, updateFunction?: () => void) => {
	const handleObserver = useCallback((entries) => {
		const target = entries[0];
		if (target.isIntersecting) {
			updateFunction && updateFunction();
		}
	}, []);

	useEffect(() => {
		const option = {
			root: null,
			rootMargin: "0px",
			threshold: 1,
		};
		const observer = new IntersectionObserver(handleObserver, option);
		loader.current && observer.observe(loader.current as any);
		return () => observer.disconnect();
	}, [handleObserver, loader.current]);

	return null;
};

export default useInfiniteScroll;
